/** Listing open-caps — separate from account-type eligibility (r2rAccountTypes). */

export const DEFAULT_LISTING_CAP = 50;

/** @type {Record<string, number>} */
export const LISTING_CAP_BY_USER_TYPE = {
  non_supporting_hobbyist_buy_sell: 50,
  supporting_hobbyist_buy_sell: 150,
  commercial_non_sponsor: 500,
  commercial_sponsor: 500,
};

/**
 * Group id → cap. Keys are environment names matching R2R_ENV.
 * A user may match multiple; resolveListingCap takes the max.
 */
export const LISTING_CAP_BY_GROUP_ID = {
  production: {
    2: 50,
    24: 150,
    271: 150,
    281: 500,
    18: 500,
    38: 500,
    196: 500,
    198: 500,
    204: 500,
    222: 500,
    223: 500,
  },
  test9: {
    2: 50,
    24: 150,
    255: 150,
    256: 500,
    18: 500,
    38: 500,
    195: 500,
    196: 500,
    198: 500,
    204: 500,
    222: 500,
    223: 500,
  },
};
